import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
	header: {
		home:"首页",
		Classes:"常规课",
		Camps:"夏令营",
		private:"私教课",
		competition:"演讲和辩论比赛",
		Community:"社区",
		Calendar:"日历",
		Teachers:"老师",
		About:"关于我们",
		Cart:"购物车",
		login:"登录",
		success:"操作成功",
		check:"请勾选要操作的数据",
		FAQ:"常见问题",
		COURSES:"个人中心",
		input:"请输入",
		select:"请选择",
		LOGOUT:"退出",
		confirm_delete:"确定退出吗？",
		confirm_del:"确定删除吗？",
		del_success:"删除成功",
		tips:"提示",
		resetPassword:"重置成功，请使用新密码",
		go_cart:"购物车",
		continue:"继续购物",
		upload_success:"上传成功",
		activity:"活动",
		picture_preview:"图片预览",
	},
	index:{
		connection:'连接超时，请检查本地网络或稍晚重试',
		no_data:"没有数据了",
		promotion:'促销',
		roadmap:'路线图',
		learn:'学习中心',
		video:'视频',
		awards:'记录奖项',
		news:'新闻',
		events:'活动',
		user_name:'账号',
		password:'密码',
		p1:'忘记密码了',
		p2:'输入您的用户名或电子邮件地址，我们将向您发送一个链接来重置您的密码。',
		p3:'重置密码',
		FORGOT:'忘记密码',
		RESET:'重置密码',
		Back:'返回',
		categories:'课程类型',
		enter:'在此处输入产品标题。。。',
		view:'搜索',
		logo_tips:'当前用户无法访问此页面请重新登录',
		added_to_cart:"加入购物车成功",
		logo_tips1:"请查看虚拟班级以获取老师的反馈和作业",
		logo_tips_buttom_ok:'虚拟班级使用教程',
		logo_tips_buttom_cancel:'关闭',
		logo_tips_buttom_classroom:'进入虚拟班级',
	},
	footer:{
		FAQ:"常见问题",
		Terms:"法律条款",
		Team:"团队",
		teacher_apply:"教师申请",
		Contact:"联系我们",
		Privacy:"隐私",
		Copyright:"Copyright © 2026 Able2Shine & Dalian Xinyi Technology Co., Ltd. All Rights Reserved.",
	},
	navleft:{
		dashboard:"个人中心",
		course:"我的课程\n（包括長期私教课）",
		camp:"我的夏令营",
		private:"短期私教课",
		orders:"我的订单",
		orders_camps:"夏令营订单",
		account:"修改密码",
		friend:"邀请好友",
		credits:"积分",
		child:"学生信息",
		virtual:"虚拟班级",
		information:"资讯中心",
		leave:"请假",
		edit:"设置",
		read:"全部已读",
		coupon:"优惠券",
		receive:"领取优惠券",
	},
	course:{
		type:'类型',
		Filter:'筛选',
		Search:'搜索',
		Reset:'重置',
		Search_bon:'搜索',
		Age:'年龄',
		Teacher:'教师',
		Season:'学期',
		Site:'地点',
		time:'时间',
		Class:'上课日',
		tab_Teacher:'教师',
		tab_Name:'标题',
		tab_Price:'价格',
		tab_Enroll:'操作',
		tab_session:'学期',
		tab_week:'星期',
		tab_cate:'分类',
		tab_price:'学费',
		tab_center:'学习中心',
		tab_class_num:'总课次',
		tab_age:'年龄',
		tab_date:'日期',
		tab_time:'时间',
		Add_Cart:'加入购物车',
		Filter_Age:'按年龄筛选',
		Filter_Teacher:'按教师筛选',
		Filter_Class:'按上课日期筛选',
		learn_center:'学习中心',
		ClassSize:'班级规模',
		people:'人',
		lunch_price:'午餐金额',
		look_price:'课后托管费用',
		look_price1:'上午课后托管费用',
		look_price2:'下午课后托管费用',
		have_lunch:'午餐',
		have_look:'课后托管',
		have_lunch1:'午餐',
		have_look1:'需要课后托管',
		Weeks:'周',
		children:'学生',
		end_time:'结束时间',
		private_course:'私密课程',
		selected_course:'已选课程',
		selected_course1:'已选课程总金额：',
		activity_name:'活动',
		activity_num:'活动人数',
		image:'封面图',
		early_end_time:'结束时间',
	},
	teacher_apply:{
		FirstName:'名字',
		LastName:'姓',
		Email:'电子邮件',
		Phone:'手机',
		Address:'地址',
		YouCanTeach:'你能教哪些课程？',
		teaching_experience:'教学经历',
		style:'请用三个描述性的词来描述你的教学风格',
		resume:'把你的简历复制粘贴到下面',
		rules_first_name:'请输入名字',
		rules_last_name:'请输入姓',
		rules_email:'请输入邮箱地址',
		rules_phone:'请输入手机号',
		rules_phone_:'请输入有效手机号',
		rules_course:'请选择课程',
		rules_history:'请输入教育史与教学经验',
		Submit:'提交',
		Evidence:'请上传与您教学经验相关的照片或视频',
		Select_Files:'选择文件',
		word_file:'请上传您的简历文件（WORD文件或者PDF文件）',
	},
	course_info:{
		description:'产品描述',
		additional:'附加信息',
		reviews:'评论',
		friend:'推荐',
		Enroll:'立即注册',
		AddCart:'添加到购物车',
		Teacher:'教师',
		Date:'日期',
		Time:'时间',
		Site:'学习中心',
		Ages:'年龄',
		ClassDay:'上课日',
		Theme:'主题',
		Session:'学期',
		ClassSize:'班级规模',
		Address:'地址',
		ClassInfo:'班级信息',
		ClassHighlight:'课堂亮点',
		TeacherInformation:'教师信息',
		description_list:'你感兴趣的',
		options:'查看',
		click_copy:'点击‘复制’邀请链接',
		click_copy_TokenId:'请先登录',
		copy:'复制',
		copy_success:'复制成功',
		copy_error:'该浏览器不支持自动复制',
		no_course_dates:'不上课时间',
		class_num:'总课次',
		introduce:'说明',
		early:'早鸟时间',
		competition_description:'大赛说明',
		sign_up:'报名',
		Date_time:'日期&时间',
	},
	Teacher_index:{
		TeacherClasses:'老师的课堂',
		name:'见见我们专业、经验丰富、富有爱心的老师',
		introduce:'我们有一个专业的招聘和指导团队，以寻找有才华的专业人士。我们优秀的美国教师和教练团队帮助我们的学生不仅培养了口语和写作能力，而且培养了敢于真诚和自爱的勇气。此外，我们还开发自己的课程，整合所有社区资源。',
	},
	news:{
		More:'阅读更多',
		Posts:'相关新闻',
	},
	cart:{
		name:'我的购物车',
		Teacher	:'教师',
		Program	:'编码',
		Student	:'学生(多选)',
		student	:'学生',
		Price:'价格',
		Quantity:'数量',
		Total:'总计',
		Operation:'操作',
		Couponcode:'优惠代码',
		Applycoupon:'申请优惠券',
		Updatecart:'更新购物车',
		Carttotals:'购物车总计',
		discounts:'折扣',
		Subtotal:'小计',
		Tax:'税收',
		Continueshopping:'继续购物',
		Proceedtocheckout:'结账',
		please_choose:'请选择学生',
		subtotal_of_general_courses:'常规课小计',
		summer_camp_subtotal:'夏令营小计',
		private_camp_subtotal:'私教课小计',
	},
	cart_settlement:{
		name:'我的订单',
		order:'订单信息',
		select:'优惠',
		payment:'付款方式',
		amount:'订单金额',
		teacher:'教师：',
		program:'编码：',
		student:'学生：',
		price:'价格：',
		quantity:'数量：',
		total:'总计：',
		subtotal:'小计',
		tax:'税收',
		total_tab:'总计',
		payimmediately:'立即付款',
		input_zhif:'请选择支付方式',
		input_xinyemian:'请在新开的付款窗口进行支付',
		payment_successful:'支付成功',
		payment_failed:'支付失败',
		integral:'积分',
		available_points:'可用积分',
		using_points:'使用积分',
		coupon_get:'优惠券领取',
		coupon_get_ma:'请输入优惠券领取码',
		get_coupon:'领取',
		entry_student:'参赛学生',
		entry:'参赛作品',
		your_video:'作品名称',
		video_link:'作品链接',
		submit:'提交',
		student_information:'学生资讯',
		student_name:'学生姓名',
	},
	member_child:{
		profile:'用户信息',
		name:'学生',
		name_child:'姓名',
		year:'年-月',
		add:'添加学生',
		confirm:'确认提交',
	},
	member_account:{
		select:'选择时区',
		account:'修改密码',
		confirm:'确认提交',
		country:'国家',
		timezone:'时区',
		username:'用户名',
		email:'电子邮件地址',
		old_password:'旧密码',
		new_password:'新密码',
		confirm_password:'确认密码',
		rules_old:'请输入旧密码',
		rules_new:'请输入新密码',
		rules_confirm:'两次密码不一致',
		name:'姓名',
		tel:'电话',
		wechat_id:'微信号',
		province:'省份',
	},
	member_orders:{
		paid:'已支付',
		topaid:'待支付',
		completed:'已完成',
		course:'课程名称',
		teacher:'老师',
		student:'学生',
		original:'原价',
		discounts:'折扣',
		score:'积分',
		quantity:'数量',
		total:'总计',
		paiddate:'付款日期',
		operation:'操作',
		subtotal:'小计',
		tax:'税',
		total_tab:'总计',
		carttotals:'购物车总计',
		checkout:'继续结帐',
		order_id:'订单号',
		View:'查看详情',
		refunded:'已退款',
		payment_method:'支付方式',
		center_address:'上课地址',
		center_name:'上课链接',
	},
	member_courses:{
		current:'当前',
		future:'未来',
		finish:'完成',
		syllabus:'课程名称',
		teacher:'教师',
		date:'日期',
		course:'课程表',
		virtual:'虚拟班级',
		get_into:'进入',
		download:'下载',
	},
	member_virtual:{
		entering:'进入课堂',
		admin:'联系管理员',
		teacher:'联系老师',
		syllubus:'课程大纲',
		course_form:'课程评估表',
		download:'下载大纲',
		curriculum:'课程',
		date:'日期',
		comment:'评论',
		view:'看法',
		zoom:'上课链接',
		center_name:'上课地址',
	},
	teachers_virtual:{
		in_class:'课堂上',
		finish:'完成',
		entering:'进入课堂',
		Course:'课程评估表',
	},
	teachers_leave:{
		start:'开始日期',
		end:'结束日期',
		range:'至',
		time:'休息时间',
		reason:'原因',
	},
	member_index:{
		form:'列表',
		calendar:'日历',
		syllabus:'课程名称',
		teacher:'教师',
		date:'日期',
		course:'课程表',
		content:'备注',
		points:'积分',
	},
	index_register:{
		login_user_name:'学生账号',
		h1:"只需填写以下信息，我们会很快为您建立一个新账户",
		time_zone:"选择时区",
		country:"国家",
		Timezone:"时区",
		information:"推荐人信息",
		address:"推荐人的电子邮件地址",
		names:"销售助理姓名",
		account:"帐户详细信息",
		username:"用户名",
		email:"电子邮件地址",
		email_:"正确的邮箱地址",
		password:"密码",
		confirm_password:"确认密码",
		profile:"用户信息",
		name:"姓名",
		namekid:"学生",
		namekid_:"信息",
		yearmonth:"学生生日",
		addchild:"添加孩子",
		phone:"电话号码",
		wechat:"微信号",
		wechat_text:"如果您没有微信号，请填写不适用",
		city:"市州（或省）",
		complete:"完成注册",
		thetwo:"两次密码不一致",
		successful:"注册成功",
		perfect:"请完善信息",
		code:"短信验证码",
		code_email:"邮箱验证码",
		phone_code:"发送验证码",
		Sent_successfully:"发送成功",
		wrong_password:"密码错误",
		unlocking:"解锁",
		adult:"是否是成人",
		inactive:"不是成人",
		active:"是成人",
		user_name:"用户名",
		password:"密码",
		grade:"年级",
		student_name:"学生姓名",
		student_email:"学生邮箱",
		expired:"课程过期了！请选择报名未过期课程。",
		expired1:"这周夏令营已经开始了，请确认参加吗？",
		code_register:"验证码注册",
	},
	index_login:{
		h1:'登录以继续',	
		h2:'还不是会员？ ',
		h3:'立即注册',
		h4:'教师登录',
		username:'用户名',
		password:'密码',
		login:'立即登录',
		forgot:'忘记密码了',
		select:'请选择',
		password_login:'密码登录',
		code_login:'验证码登录',
		tel:'手机号',
		code:'验证码',
	},
	member_friend:{
		p1:"请注册以获取您的推荐链接。",
		email:"你的电子邮件",
		generate:"生成",
	},
	payment:{
		tips:'支付成功，查看订单或返回首页',
		order:'查看订单',
		index:'返回首页',
	},
	virtual:{
		list:'课程列表',
		mail:'站内信',
		teacher_news:'老师交流',
		comment:'点评',
		comment_history:'点评历史',
		task:'作业',
		hair_task:'留作业',
		upload_task:'交作业',
		upload_task_:'已交作业',
		batch_task:'批作业',
		course_assess:'课堂评估',
		course_assess_history:'课堂评估历史',
		certificate:'结业证书',
		feedback:'意见反馈',
		feedback_history:'意见反馈历史',
		on:'序号',
		time:'日期',
		course:'课程',
		status:'状态',
		leave:'请假',
		signin:'签到',
		course_name:'班级名称',
		teacher_name:'老师姓名',
		course_time:'上课时间',
		course_status:'课程状态',
		leave_history:'请假历史',
		del:'删除',
		edit:'编辑',
		return:'返回',
		all:'全部',
		unread:'未读',
		read:'已读',
		unread_quantity:'未读数量',
		teachers_index:'点名',
		teachers_index_history:'点名历史',
		teachers_task:'作业',
		teachers_parent:'家长交流',
		teachers_letter:'老师来信',
		teachers_letter_history:'老师来信历史',
		teachers_assess:'课堂评估',
		teachers_certificate:'结业证书',
		teachers_leave:'请假',
		operation:'操作',
		select:'选择',
		student:'学生',
		parent:'家长',
		submit:'提交',
		class_size:'班级人数',
		course_today:'今日课程',
		arrived_num:'已到人数',
		not_arrived_num:'未到人数',
		name:'标题',
		content:'内容',
		file_upload:'附件上传',
		add_file:'加附件',
		file:'附件',
		upload:'上传',
		download:'下载',
		time:'时间',
		reason:'理由',
		content_work:'批改内容',
		letter_type:'类型',
		children_id:'选择学生',
		send:'发送',
		score:'评分',
		assessment:'评估',
		issue_certificate:'颁发证书',
		remarks:'备注',
		upload_video:'上传视频<20MB',
		upload_link:'视频链接>20MB',
		ok:'确定',
		cancel:'取消',
		student_name:'学生姓名',
		p_tishi:'*上传视频（文件大小<20MB）或使用Youtube链接',
		view_job:'查看作业',
		task_off:'老师还没有留作业',
		admin:'联系我们的管理员',
		comments:'给老师的评论',
		certificate_img:'长按保存图片',
		debate:'辩论评估',
	},
	footer_contact:{
		name:'你的名字',
		email:'你的电子邮件',
		code:'图形验证码',
		content:'在此处输入您的反馈',
		title:'看不清下一张',
		submit:'提交',
		success:'反馈成功',
	},
	assess:{
		title:'听、说、读、写综合课程，增强年轻人的信心和领导力灯光、相机、行动！',
		student:'学生',
		teacher:'老师',
		class:'课程',
		location:'学习中心',
		time:'上课时间',
		session:'学期',
		notes:'教师评语',
		sound:'教师录音',
	},
	member_coupon:{
		name:'优惠券名称',
		condition:'使用条件',
		discount:'金额/折扣',
		superposition:'叠加',
		date:'有效期',
		frequency:'使用次数',
		range:'使用范围',
		look_up:'查看',
		code:'领取码',
		cancel:'取消',
		submit:'领取',
		success:'领取成功',
		range_unlimited:'不限使用范围',
		explain:'使用说明',
	},
	...zhLocale
}
export default cn;


// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js